module.exports = __webpack_public_path__ + "static/media/juan-valdez.d8da4ce6.svg";